import React, { useEffect } from "react";
import ServiceTemplate from "../components/ServiceTemplate";

import aBanner from "../images/ai-1.png";
import aBig from "../images/ai-2.png";
import aCollage from "../images/ai-3.png";

import {
  FaCheckDouble,
  FaTachometerAlt,
  FaChartLine,
  FaClock,
  FaUserShield,
  FaFileAlt
} from "react-icons/fa";

function Automation() {

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

const sidebar = [
  {
    title: "Zero Manual Correction Workload",
    icon: FaCheckDouble,
  },
  {
    title: "Accurate & Fast Evaluation",
    icon: FaTachometerAlt,
  },
  {
    title: "Progress Insights for Parents & Management",
    icon: FaChartLine,
  },
  {
    title: "Real-Time Performance Tracking",
    icon: FaClock,
  },
  {
    title: "Secure Student Data Management",
    icon: FaUserShield,
  },
  {
    title: "Detailed Reports & Analytics",
    icon: FaFileAlt,
  },
];

  const features = [
    "PLC & HMI development",
    "SCADA & data historian",
    "Panel engineering & wiring",
    "Site commissioning & testing",
    "AMC & lifecycle support",
  ];

  return (
    <ServiceTemplate
      title="AI IN EDUCATION "
      bannerImage={aBanner}
      bigImage={aBig}
      collageImage={aCollage}
      sidebarItems={sidebar}
      features={features}
    />
  );
}

export default Automation;
